import { render } from "./ListeNotes.vue?vue&type=template&id=0163f51c&ts=true"
import script from "./ListeNotes.vue?vue&type=script&lang=ts"
export * from "./ListeNotes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__